import OraclePage from './OraclePage'

export default OraclePage

// eslint-disable-next-line import/export
export * from './OraclePage'
